import React from 'react';
import { UserOutlined } from '@ant-design/icons';

const WarehouseTopbar = ({ title, subtitle, icon }) => {
  const userName = localStorage.getItem('uname') || sessionStorage.getItem('uname') || 'Manager';

  return (
    <div style={{
      backgroundColor: '#8B4513',
      color: '#fff',
      padding: '20px 24px',
      marginBottom: '24px',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    }}>
      <div>
        <h2 style={{ margin: 0, color: '#fff', fontSize: '24px', fontWeight: 'bold' }}>
          {icon && <span style={{ marginRight: '10px' }}>{icon}</span>}
          {title}
        </h2>
        {subtitle && (
          <p style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: '14px', margin: '5px 0 0 0' }}>
            {subtitle}
          </p>
        )}
      </div>
      <div>
        <span style={{ color: '#fff', fontSize: '16px' }}>
          <UserOutlined style={{ marginRight: '8px' }} />
          {userName}
        </span>
      </div>
    </div>
  );
};

export default WarehouseTopbar;
